export default __webpack_public_path__ + "static/media/img_logo_skoda.d2190fcb.svg";